import Error404 from "../../theme/mantis/pages/maintenance/404";

const NotFound = () => {
    return (
        <Error404/>
    )
}

export default NotFound;
